import { Component } from 'react'
import { Button, Tooltip } from 'antd';
import { LogoutOutlined, MenuUnfoldOutlined, MenuFoldOutlined, NotificationOutlined } from '@ant-design/icons';
import Cookies from 'js-cookie';
import { withRouter, RouteComponentProps } from "react-router-dom";
import { connect } from 'react-redux';
import { isAuthintecated, toggleSideBar, getAccessRoutes, setIsHR } from '../../stores/actions';
import { request } from '../../apis';
import { logoutApi } from '../../utils/apisConsts';
import { Region } from '../../utils/commonInterfaces';
import { getRegion } from '../regionWrapper';
import Logo from '../../assets/images/loginLogoIcon.34b51808.png';
import CountryFlag from '../countryFlag';
import GlobalSearch from './globalSearch';

interface Props extends RouteComponentProps<any> {
  isAuthintecated: any,
  isHR: boolean,
  toggleSideBar: any,
  is_bar_collapsed: boolean,
  getAccessRoutes: any,
  request: any
  setIsHR?: (value: boolean | null) => void
}

class Navigation extends Component<Props> {
  state = {
    loggingOut: false,
  };
  region: Region = getRegion() ?? Region.EG;

  logOut = async () => {
    if (this.state.loggingOut) return;

    if (this.region === Region.EG) {
      Cookies.remove('token');
      this.props.setIsHR?.(null);
      this.props.isAuthintecated(false)
      this.props.history.push('/log-in')
      this.props.getAccessRoutes([])
      return;
    }

    this.setState({ loggingOut: true });
    try {
      const response = await this.props.request({
        url: logoutApi,
        method: 'post',
      });

      if (response?.data?.status === 200 || response?.status === 200) {
        this.props.isAuthintecated(false);
        this.props.getAccessRoutes([]);
        this.props.history.push('/log-in');
      }
    } catch (error) {
      console.error('Logout API error:', error);
      this.props.isAuthintecated(false);
      this.props.getAccessRoutes([]);
      this.props.history.push('/log-in');
    } finally {
      this.setState({ loggingOut: false });
    }
  }

  collapseSideBar = () => {
    this.props.toggleSideBar(!this.props.is_bar_collapsed)
  }

  render() {
    const { is_bar_collapsed, isHR, location, history } = this.props;
    const isReleaseNotesPage = location.pathname === '/release-notes';
    const regionLabel = this.region === Region.SE ? 'Saudi' : 'Egypt';
    const collapseLabel = is_bar_collapsed ? 'Expand sidebar' : 'Collapse sidebar';

    return (
      <header className="appNav">
        <div className="appNav-left">
          <Tooltip title={collapseLabel} placement="bottom">
            <Button
              type="text"
              className="appNav-iconBtn appNav-collapse"
              onClick={this.collapseSideBar}
              aria-label={collapseLabel}
              icon={is_bar_collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            />
          </Tooltip>
          <div className="appNav-brand">
            <img className="appNav-logo" src={Logo} alt="Nowpay" />
            <div className="appNav-brandText">
              <span className="appNav-title">Operations</span>
              <span className="appNav-region">
                <span className="appNav-flag" aria-hidden="true">
                  <CountryFlag
                    code={this.region === Region.SE ? "sa" : "eg"}
                    className="appNav-flagImg"
                    width={26}
                    height={17}
                  />
                </span>
                {regionLabel}
              </span>
            </div>
          </div>
        </div>

        <GlobalSearch />

        <div className="appNav-actions">
          {isHR === false && (
            <Button
              type="text"
              className={`appNav-action${isReleaseNotesPage ? ' is-active' : ''}`}
              icon={<NotificationOutlined />}
              onClick={() => history.push('/release-notes')}
            >
              <span className="appNav-actionLabel">What's New</span>
            </Button>
          )}
          <Button
            type="text"
            className="appNav-action appNav-action--logout"
            icon={<LogoutOutlined />}
            loading={this.state.loggingOut}
            onClick={this.logOut}
          >
            <span className="appNav-actionLabel">Log out</span>
          </Button>
        </div>
      </header>
    );
  }
}
const mapStateToProps = (state: any) => ({
  is_bar_collapsed: state.componentReducer.is_bar_collapsed,
  isHR: state.auth.isHR,
})
export default withRouter(connect(mapStateToProps,{ isAuthintecated, toggleSideBar, getAccessRoutes, setIsHR, request })(Navigation))
